import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { UserDetails } from '../redux/actions/authActions';

const PrivateRoute = ({ children }) => {
    const dispatch = useDispatch();
    const { auth_token, user } = useSelector((state) => state.auth);
    
    // Check sessionStorage as well (in case Redux state is not initialized)
    const sessionAuthToken = sessionStorage.getItem('auth_token');
    const sessionUser = sessionStorage.getItem('user');
    
    const hasAuth = auth_token || sessionAuthToken;
    const hasUser = user || sessionUser;
    
    // If auth token exists but user data is missing, fetch it
    useEffect(() => {
        if (hasAuth && !hasUser) {
            dispatch(UserDetails());
        }
    }, [hasAuth, hasUser, dispatch]);
    
    if (!hasAuth) {
        return <Navigate to="/login" />;
    }
    
    return children;
};

export default PrivateRoute;